import parse from "html-react-parser";
import DOMPurify from 'dompurify';

export const highlightMatches = (html, matches, messageId) => {
  if (!matches || matches.length === 0) {
    // Sanitize the HTML but preserve the structure
    const sanitized = DOMPurify.sanitize(html, {
      ADD_ATTR: ['target', 'rel'],
      ADD_TAGS: ['iframe'],
      FORBID_ATTR: ['style*=position:fixed', 'style*=position: fixed', 'style*=position:absolute', 'style*=position: absolute', 'style*=background', 'style*=background-color'],
    });
    return parse(sanitized);
  }

  const sorted = [...matches].sort((a, b) => a.start_at - b.start_at);
  let result = html;

  sorted.forEach(({ start_at, end_at }, index) => {
    const before = result.slice(0, start_at);
    const match = result.slice(start_at, end_at);
    const after = result.slice(end_at);
    result = `${before}<span id="result_${messageId}_${index}" class="highlighted-text" data-highlight-index="${index}" style="background-color: #FFEB3B; display: inline; padding: 0 2px; border-radius: 2px;">${match}</span>${after}`;
  });
  
  // Sanitize the resulting HTML with highlights but restrict global styling
  const sanitized = DOMPurify.sanitize(result, {
    ADD_ATTR: ['target', 'rel', 'data-highlight-index', 'id'],
    ADD_TAGS: ['iframe'],
    FORBID_ATTR: ['style*=position:fixed', 'style*=position: fixed', 'style*=position:absolute', 'style*=position: absolute', 'style*=background', 'style*=background-color'],
    ALLOW_DATA_ATTR: true,
  });
  
  return parse(sanitized);
};
